import { useRef, useState } from 'react'

import type { VisibleRows } from './useVisibleRows'
import type { Any } from '@api/orvalFetcher'
import type { RequiredToUpdateDict } from '@hooks/useRealtimeTableSocket'

export const useVisibleRowsOutsideState = () => {
  const requiredToUpdateDictRef = useRef<RequiredToUpdateDict>({})
  const [visibleRows, setVisibleRows] = useState<VisibleRows<Any>>([])

  return { requiredToUpdateDictRef, visibleRows, setVisibleRows }
}
